/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Net_WeightInputs */

const en_inbound_field_net_weight = /** @type {(inputs: Inbound_Field_Net_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net weight (kg)`)
};

/**
* | output |
* | --- |
* | "Net weight (kg)" |
*
* @param {Inbound_Field_Net_WeightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_net_weight = /** @type {((inputs?: Inbound_Field_Net_WeightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Net_WeightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_net_weight(inputs)
});